import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SchemaMarkup from "@/components/SchemaMarkup";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedArticles from "./components/FeaturedArticles";
import LatestArticles from "./components/LatestArticles";
import CTASection from "./components/CTASection";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <>
      <SchemaMarkup
        type="Organization"
        data={{
          name: "91EatGossip",
          alternateName: "91吃瓜网",
          url: "http://msldyun.cn/",
          logo: "http://msldyun.cn/logo.png",
          description:
            "91EatGossip是最专业的中文娱乐八卦资讯门户，提供24小时不间断的明星丑闻、网红爆料、综艺内幕独家内容。",
          sameAs: [
            "http://msldyun.cn/",
          ],
        }}
      />
      <SchemaMarkup
        type="WebSite"
        data={{
          name: "91EatGossip - 91吃瓜网最新地址发布页",
          url: "http://msldyun.cn/",
          potentialAction: {
            "@type": "SearchAction",
            target: "http://msldyun.cn/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaMarkup
        type="WebPage"
        data={{
          name: "91EatGossip - 91吃瓜网最新地址发布页 | 吃瓜入口24小时不间断",
          description:
            "91EatGossip最新地址发布页为您提供永不迷路的吃瓜入口。明星网红丑闻24小时不间断更新，高清视频免费在线观看。",
          url: "http://msldyun.cn/",
          isPartOf: { "@id": "http://msldyun.cn/" },
          primaryImageOfPage: {
            "@type": "ImageObject",
            url: "http://msldyun.cn/og-image.jpg",
          },
        }}
      />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <LatestArticles />
          <CTASection />
          <TestimonialSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}
